/**
 * Pure helpers for Val codebook parse race control (epoch / single-flight / orphan).
 * Kept out of the React context so the rules can be unit-tested.
 */

export function codebookParseFlightKey(
  fileId: string,
  sheet: string | undefined,
  codebookType: string,
): string {
  return `${fileId}|${sheet || 'csv'}|${codebookType}`
}

/** Apply a parse result when its epoch still owns the slot, or the sheet still matches. */
export function shouldApplyParsedSchema(
  epochOk: boolean,
  sheetOk: boolean,
): boolean {
  return epochOk || sheetOk
}

/** Skip a second orphan re-parse for the same file|sheet|type. */
export function shouldSkipDuplicateParse(
  key: string,
  orphanKey: string | null,
  inFlightKey: string | null,
): boolean {
  return orphanKey === key || inFlightKey === key
}

/** Val L2/L3 runs live under the STRIDE study OID but surface in codebook progress. */
export function isValLayerFormOid(formOid: string): boolean {
  return formOid.startsWith('val:scenarios:') || formOid.startsWith('val:gaps:')
}

export function mergeSuiteRunsByFormOid<T extends { form_oid: string }>(
  existing: T[],
  incoming: T[],
): T[] {
  const byOid = new Map(existing.map((r) => [r.form_oid, r]))
  for (const r of incoming) byOid.set(r.form_oid, r)
  return [...byOid.values()]
}
